import React, { Component } from 'react'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import http from '../../services/httpService'

class MessagesTable extends Component {
  state = { data: [], pages: null, loading: true }
  columns = [
    {
      id: 'id', Header: 'ID', accessor: d => d.id, filterable: true, width: 280
    },
    { id: 'templateName', Header: 'Template', accessor: d => d.templateName, filterable: true, width: 150 },
    { id: 'subject', Header: 'Subject', accessor: d => d.subject, filterable: true, width: 250 },
    { id: 'toAddress', Header: 'To Address', accessor: d => d.toAddress, filterable: true, width: 200 },
    { id: 'fromAddress', Header: 'From Address', accessor: d => d.fromAddress, filterable: true, width: 200 },
    { 
      id: 'type', Header: 'Type', accessor: d => d.type, filterable: true, width: 100,
      Cell: props => {
        const typeMap = { 1: 'Email', 3: 'Push', 4: 'Telegram' };
        return typeMap[props.value] || props.value;
      }
    },
    { 
      id: 'state', Header: 'State', accessor: d => d.state, filterable: true, width: 120,
      Cell: props => {
        const stateMap = { 0: 'Not Sent', 1: 'Sent', 2: 'Retry Failed', 3: 'Spammy' };
        return stateMap[props.value] || props.value;
      }
    },
    { 
      id: 'source', Header: 'Source', accessor: d => d.source, filterable: true, width: 100,
      Cell: props => {
        const sourceMap = { 0: 'Website', 1: 'Resend', 2: 'Agent', 3: 'CMS' };
        return sourceMap[props.value] || props.value;
      }
    },
    { id: 'retryCount', Header: 'Retries', accessor: d => d.retryCount, sortable: false, width: 80 },
    { id: 'sendDate', Header: 'Send Date', accessor: d => d.sendDate, filterable: true, width: 160 },
    { id: 'createDate', Header: 'Created', accessor: d => d.createDate, filterable: true, width: 160 }
  ]

  fetchData = async (state, instance) => {
    this.setState({ loading: true })

    const { pageSize, page, sorted, filtered } = state
    const url = `messages/user/${this.props.userId}`
    const { data } = await http.post(url, { pageSize, page, sorted, filtered })

    this.setState({
      data: data.rows,
      pages: data.pages,
      loading: false
    })
  }

  render () {
    const { data, loading, pages } = this.state
    const columns = this.columns
    return (
      <div className="my-4">
        <h5>Messages</h5>
        <ReactTable manual data={data} pages={pages} loading={loading} columns={columns}
                    filterable onFetchData={this.fetchData}
        />
      </div>
    )
  }
}

export default MessagesTable